<template>
  <sa-page-layout :btnSaveVisible="true" :btnAnnullaVisible="true" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
    <template slot="table-body">
      <presidi-prestazioni-edit-component ref="PresidiPrestazioniEditComponent" :showModalLoading="showModalLoading" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></presidi-prestazioni-edit-component>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import PresidiPrestazioniEditComponent from "../components/PresidiPrestazioniEditComponent.vue";
export default {
  components: { SaPageLayout, PresidiPrestazioniEditComponent },
  data() {
    return {
      showModalLoading: false,
      pathResource: "/ricettaprestazionipresidio",
      linkback: null,
      jsonData: {},
    };
  },
  mounted() {
    let me = this;
    me.id = this.$route.params.id;
    me.linkback = "/presidiprestazioni";
  },
  methods: {
    onUpdateJsonData(data) {
      let me = this;
      me.jsonData = data;
    },
    onBeforeLoadData() {},
    onAfterLoadData() {},
  },
};
</script>

<style></style>
